import React, { Component } from "react";
import { UpdateUserDetail, UserDetail } from "../../models/users";
import { PnkConnect } from "../../pnk-react/pnk-miniredux";
import OTPModal from "./otpModal";
import UserProfilePage from "./userProfile";
// import profile from '../../assets/images/avatar.png';
// const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/users/'


class userProfile extends Component {
    constructor() {
        super()
        this.state = {
            getUser: false,
            updateUser: false,
            userId: '',
            userName: "",
            userEmail: '',
            userMobile: '',
            fileUserImage: '',
            userEmailStatus: '',
            userMobileStatus: '',
            txtVerificationOtp: '',
            showUpdateBtn: false,
            isModalOpen: false,
            verificationType: '',
            count: 59,
            profilePicStatus: 'Normal',
            Profilemode: 'Normal',
            //   editBtn:'Edit',
            userAge: '',
        }

        this.updateProfileData = {};
        this.verifyData = {}
        this.editDataObj = {}
    }

    componentDidMount = () => {
        this.setState({
            userId: this.props.componentprops.match.params.id,
            getUser: true,

        })
    }

    ChangeMode = () => {
        this.setState({
            Profilemode: 'Update'
        })
    }

    HandleUserImage = (e) => {
        // alert('lll' + e.target.value)
        this.editDataObj[e.target.name] = e.target.value;

        console.log('ssss', this.editDataObj);

        this.setState({
            showUpdateBtn: true,
            fileUserImage: e.target.value
        })

    }

    HandleVerificationInputs = (e) => {

        const val = e.target.value;
        const name = e.target.name;
        this.setState({ [name]: val });
        if (name === 'txtVerificationOtp') this.state.txtVerificationOtp = val;
    }

    HandleProfileInputs = (e) => {
        //  alert('jjj')
        const val = e.target.value;
        const name = e.target.name;
        this.setState({ [name]: val });
        //  this.editDataObj[name] = val;
        if (name === "txtUserName") this.state.userName = val;
        else if (name === "txtUserMobile") this.state.userMobile = val;
        else if (name === 'txtUserAge') {
            this.HandleDateTime();
        }

    }

    HandleDateTime = () => {
         //  alert('kkk')
        // alert( new Date().getFullYear() - 55)
        let finaldatetime = '';

        let config = {
            // day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            // shortDay: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            // MDW: 'D, MM-d',
            // YM: 'yyyy-M',
            OK: 'OK',
            CANCEL: 'CANCEL',
            CLEAR: 'CLEAR'
        }
        var DateTimePicker = require('date-time-picker')
        let that = this;


        let maxAge = new Date().getFullYear() - 55;
        let maxMonth = new Date().getMonth() + 1;

        if(maxMonth<10){
            maxMonth = '0' + maxMonth;
        }
       
        //   alert(maxMonth)
        let maxDate = new Date().getDate();
        if(maxDate<10){
        maxDate = '0' + maxDate;
        }
        //  alert(maxDate)
        maxAge = maxAge + '-' + maxMonth + '-' + maxDate;
        //alert(maxAge)

        let options = {
            lang: 'EN', // default 'EN'. One of 'EN', 'zh-CN'
            format: 'yyyy-MM-dd', // default 'yyyy-MM-dd'
            // default: '2016-10-19', // default `new Date()`. If `default` type is string, then it will be parsed to `Date` instance by `format` . Or it can be a `Date` instance
            //  min: '2017-01-01', // min date value, `{String | Date}`, default `new Date(1900, 0, 1, 0, 0, 0, 0)`
            max: maxAge // max date value, `{String | Date}`, default `new Date(2100, 11, 31, 23, 59, 59, 999)`
        }

        var datePicker = new DateTimePicker.Date(options, config)
        datePicker.on('selected', function (formatDate, now) {
            // alert('hii'+formatDate)
            // formatData = 2016-10-19
            // now = Date instance -> Wed Oct 19 2016 20:28:12 GMT+0800 (CST)
            finaldatetime = formatDate;
            that.setState({
                userAge: finaldatetime
            })

        })
        datePicker.on('cleared', function () {
            // clicked clear btn
            finaldatetime = finaldatetime;
            that.setState({
                userAge: finaldatetime
            })
        })
    }

    UpdateProfile = (e) => {
        //   alert('jjj')
        this.updateProfileData = {
            txtUserName: this.state.userName,
            txtUserMobile: '91' + this.state.userMobile,
            txtUserAge: this.state.userAge,
            //  fileUserImage:this.state.fileUserImage

        }

        this.setState({
            updateUser: true,

        })

       // console.log(this.updateProfileData)
    }

    ShowOtpModal = (type) => {
        //alert('hhh')
        this.setState({
            isModalOpen: true,
            verificationType: type
        })

        this.SendOtp();
    }

    SetCoundown = () => {
        this.setState({
            count: 0
        })
    }

    SendOtp = () => {
        //  alert('send otp')
        this.setState({
            count: 59
        })
        //   setInterval(()=>{

        //          if(this.state.count>0){
        //              this.setState({
        //                  count:this.state.count-1
        //              })
        //             // console.log(this.state.count)
        //          }
        //          else{
        //              return false
        //          }

        //   },1000)

    }

    VerifyOtp = () => {

        this.verifyData = {
            txtVerificationOtp: this.state.txtVerificationOtp
        }

        this.setState({
            isModalOpen: false,
            count: 59,
            txtVerificationOtp: ''
        })

      //  console.log(this.verifyData)

    }

    UploadProfilePic = (e) => {

        //    console.log(this.state.fileUserImage)

        this.updateProfileData = {
            fileUserImage: this.state.fileUserImage
        }

        this.setState({
            updateUser: true,
        })

        // console.log('uuuuuu')
    //    console.log(this.updateProfileData)

    }
    HandleUpdateUserDetailsSuccessResponse = (res) => {
        if (res !== false) {
        //    console.log(JSON.stringify(res))
            // if(res.data.userdetails.rows[0].profile_pic === '' || res.data.userdetails.rows[0].profile_pic === undefined || res.data.userdetails.rows[0].profile_pic === null){
            //     this.setState({
            //         fileUserImage:profile,
            //     })
            // }
            // else{
            //     this.setState({
            //         fileUserImage:res.data.userdetails.rows[0].profile_pic,
            //     })
            // }
            this.setState({
                getUser: true,
                // renderChild:true,
                // mode: 'edit',
                showUpdateBtn: false,
                //  fileUserImage:'',
                Profilemode: 'Normal',
                updateUser: false
            })
        }
        else {
            this.setState({
                Profilemode: 'Normal',
                updateUser: false,
                //  fileUserImage:'',
                showUpdateBtn: false
            })
        }

    }


    HandleGetUserDetailsSuccessResponse = (res) => {
        if (res !== false) {
         //   console.log(JSON.stringify(res))
            // if(res.data.userdetails.rows[0].profile_pic === '' || res.data.userdetails.rows[0].profile_pic === undefined || res.data.userdetails.rows[0].profile_pic === null){
            //     this.setState({
            //         fileUserImage:profile,
            //     })
            // }
            // else{
            //     this.setState({
            //         fileUserImage:res.data.userdetails.rows[0].profile_pic,
            //     })
             let userMobile;
            if(res.data.userdetails.rows[0].user_mobile){
                userMobile = res.data.userdetails.rows[0].user_mobile.slice(2); 
            }
            else{
                userMobile = res.data.userdetails.rows[0].user_mobile
            }
            // }
            this.setState({
                getUser: false,
                renderChild: true,
                mode: 'edit',
                Profilemode: 'Normal',
                userId: res.data.userdetails.rows[0]._id,
                userName: res.data.userdetails.rows[0].user_full_name,
                userEmail: res.data.userdetails.rows[0].user_email,
                userAge: res.data.userdetails.rows[0].user_dob,
                
                userMobile: userMobile,
                userEmailStatus: res.data.userdetails.rows[0].email_status,
                userMobileStatus: res.data.userdetails.rows[0].mobile_status,
                fileUserImage: res.data.userdetails.rows[0].profile_pic,
            })
        }
        else {
            this.setState({
                getUser: false
            })
        }

    }

    render() {
        return (
            <div>
                <UserProfilePage {...this.props} mystate={this.state}
                    HandleProfileInputs={this.HandleProfileInputs}
                    UpdateProfile={this.UpdateProfile}
                    ChangeMode={this.ChangeMode}
                    ShowOtpModal={this.ShowOtpModal}
                    UploadProfilePic={this.UploadProfilePic}
                    HandleUserImage={this.HandleUserImage}
                    HandleDateTime={this.HandleDateTime}
                    editDataObj={this.editDataObj}
                />
                <OTPModal {...this.props} mystate={this.state}
                    VerifyOtp={this.VerifyOtp}
                    SendOtp={this.SendOtp}
                    HandleVerificationInputs={this.HandleVerificationInputs}
                    SetCoundown={this.SetCoundown}

                />
                {((this.state.getUser === true) ? UserDetail(this.props.PnkStore, this.state.userId, this.HandleGetUserDetailsSuccessResponse) : "")}
                {((this.state.updateUser === true) ? UpdateUserDetail(this.props.PnkStore, this.state.userId, this.updateProfileData, this.HandleUpdateUserDetailsSuccessResponse) : "")}
            </div>
        )
    }

}

export const UserProfile = PnkConnect(userProfile, '');